import { render, staticRenderFns } from "./materialSupply.vue?vue&type=template&id=edb9c52e&scoped=true"
import script from "./materialSupply.vue?vue&type=script&lang=js"
export * from "./materialSupply.vue?vue&type=script&lang=js"
import style0 from "./materialSupply.vue?vue&type=style&index=0&id=edb9c52e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb9c52e",
  null
  
)

export default component.exports